quoteModule.factory('rateQuoteScenariosService', ['AppSettings',
    function (appSettings) {
    var rateQuoteScenariosService = {};

    var _scenarios = [1];
    var _currentScenario = 1;

    //_scenarios is an array of the current "proposals".. A sequential placeholder for
    // quotes per proposal. The list may not be contiguous because we don't reorder once
    // the user removes a scenario

    //initialize scenario
    rateQuoteScenariosService.startFirstQuoteScenario = function() {
        _scenarios = [1];
    }

    //"product scenarios" lists
    rateQuoteScenariosService.getScenarioList = function () {
        return _scenarios;
    }
    //set the current scenario the user is working with
    rateQuoteScenariosService.setCurrentScenario = function (scen) {
        _currentScenario = scen;
    }
    //get the current scenario the user is working with
    rateQuoteScenariosService.getCurrentScenario = function () {
        return _currentScenario;
    }
    //add a blank scenario
    rateQuoteScenariosService.addNewScenarioNoCopy = function (newScenarioId) {
        if (_scenarios.indexOf(parseInt(newScenarioId))<0)
            _scenarios.push(parseInt(newScenarioId));
    }
    //remove a scenario
    rateQuoteScenariosService.removeScenario = function(rmvScenarioId){
        _scenarios.splice(_scenarios.indexOf(rmvScenarioId), 1);
        if (_scenarios.length == 0)
            rateQuoteScenariosService.addNewScenario(1);

        return;
    }
    //create/copy a new scenario
    rateQuoteScenariosService.addNewScenario = function (newScenario) {
        _scenarios.push(newScenario);
    }

    rateQuoteScenariosService.initScenariosForRetrieval = function(){
        _scenarios = [];
        _currentScenario = -1;
    }
    return rateQuoteScenariosService;
}]);